export default __webpack_public_path__ + "static/media/PageNotFound.b2df4ff4.svg";